/**
 * Validates case ID format to prevent injection attacks
 * Accepts UUIDs (with or without hyphens) and alphanumeric IDs
 *
 * @param id - The case ID to validate
 * @returns true if valid, false otherwise
 *
 * @example
 * isValidCaseId('550e8400-e29b-41d4-a716-446655440000') // true (UUID)
 * isValidCaseId('550e8400e29b41d4a716446655440000')     // true (UUID no hyphens)
 * isValidCaseId('CASE-12345')                            // true (alphanumeric)
 * isValidCaseId('DROP TABLE cases')                      // false (injection attempt)
 * isValidCaseId('')                                      // false (empty)
 */
export function isValidCaseId(id: string): boolean {
  // UUID format (with hyphens): 8-4-4-4-12 hex digits
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  // UUID without hyphens
  const uuidNoHyphensPattern = /^[0-9a-f]{32}$/i;
  // Base64url charset (RFC 4648 §5): encrypted IDs are normalised to URL-safe encoding
  const generalIdPattern = /^[a-zA-Z0-9_-]{1,256}$/;

  return uuidPattern.test(id) || uuidNoHyphensPattern.test(id) || generalIdPattern.test(id);
}
